import Sortable from "@stimulus-components/sortable"

// Connects to data-controller="intake-questions-sortable"
export default class extends Sortable {
  static targets = ["item"]
  static values = { url: String, ...Sortable.values }

  // Override the defaultOptions getter to add our custom options
  get defaultOptions() {
    return {
      ...super.defaultOptions,
      animation: 150,
      handle: "[data-sortable-handle]",
      dataIdAttr: "data-id",
      onEnd: this.reorder.bind(this)
    }
  }

  async reorder() {
    const order = this.sortable.toArray()
    if (order.length === 0) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ order })
    })

    if (response.ok) {
      this.updatePositionLabels()
    } else {
      this.element.dispatchEvent(
        new CustomEvent("intake-questions-sortable:error", {
          detail: { status: response.status }
        })
      )
    }
  }

  updatePositionLabels() {
    this.itemTargets.forEach((element, index) => {
      const badge = element.querySelector("[data-role='position-label']")
      if (badge) {
        badge.textContent = `#${index + 1}`
      }
    })
  }
}
